import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { ThumbsUp, ThumbsDown, MessageSquare, Loader2 } from 'lucide-react';
import { DialogState, DialogFormState } from './types';

interface ActionDialogsProps {
  supplierName: string;
  dialogs: DialogState;
  dialogForm: DialogFormState;
  actionLoading: boolean;
  onDialogsChange: (dialogs: DialogState) => void;
  onDialogFormChange: (form: DialogFormState) => void;
  onApprove: () => void;
  onReject: () => void;
  onRequestInfo: () => void;
}

export function ActionDialogs({
  supplierName,
  dialogs,
  dialogForm,
  actionLoading,
  onDialogsChange,
  onDialogFormChange,
  onApprove,
  onReject,
  onRequestInfo,
}: ActionDialogsProps) {
  return (
    <>
      {/* Approve Dialog */}
      <Dialog open={dialogs.approve} onOpenChange={(open) => onDialogsChange({ ...dialogs, approve: open })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Approve Qualification</DialogTitle>
            <DialogDescription>
              Approve this qualification from {supplierName}?
            </DialogDescription>
          </DialogHeader>
          <Textarea
            placeholder="Add comments (optional)..."
            value={dialogForm.approveComments}
            onChange={(e) => onDialogFormChange({ ...dialogForm, approveComments: e.target.value })}
            rows={3}
          />
          <DialogFooter>
            <Button variant="outline" onClick={() => onDialogsChange({ ...dialogs, approve: false })}>
              Cancel
            </Button>
            <Button onClick={onApprove} disabled={actionLoading}>
              {actionLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ThumbsUp className="h-4 w-4 mr-2" />}
              Approve
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Reject Dialog */}
      <Dialog open={dialogs.reject} onOpenChange={(open) => onDialogsChange({ ...dialogs, reject: open })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Reject Qualification</DialogTitle>
            <DialogDescription>
              Please provide a reason for rejecting this qualification from {supplierName}.
            </DialogDescription>
          </DialogHeader>
          <Textarea
            placeholder="Enter reason for rejection..."
            value={dialogForm.rejectReason}
            onChange={(e) => onDialogFormChange({ ...dialogForm, rejectReason: e.target.value })}
            rows={4}
          />
          <DialogFooter>
            <Button variant="outline" onClick={() => onDialogsChange({ ...dialogs, reject: false })}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={onReject} disabled={actionLoading || !dialogForm.rejectReason.trim()}>
              {actionLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ThumbsDown className="h-4 w-4 mr-2" />}
              Reject
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Request Info Dialog */}
      <Dialog open={dialogs.info} onOpenChange={(open) => onDialogsChange({ ...dialogs, info: open })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Request Additional Information</DialogTitle>
            <DialogDescription>
              Describe what additional information you need from {supplierName}.
            </DialogDescription>
          </DialogHeader>
          <Textarea
            placeholder="Enter your request..."
            value={dialogForm.infoRequest}
            onChange={(e) => onDialogFormChange({ ...dialogForm, infoRequest: e.target.value })}
            rows={4}
          />
          <DialogFooter>
            <Button variant="outline" onClick={() => onDialogsChange({ ...dialogs, info: false })}>
              Cancel
            </Button>
            <Button onClick={onRequestInfo} disabled={actionLoading || !dialogForm.infoRequest.trim()}>
              {actionLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <MessageSquare className="h-4 w-4 mr-2" />}
              Send Request
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
